import React, { useState, useEffect } from "react";
import "./session.css";
import NavbarCustom from "../../../Components/NavbarCustom";
import { ImageContainer } from "../../../Components/ImageContainer";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../../APIContext/SessionContext";
import { MEDIA_BASE_URL } from "../../../Config/Config";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import Loader from "../../../Components/Loader/Loader";
import { useLocation } from "react-router-dom";

export const SessionSports = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const typeFromQuery = queryParams.get("type");
  const { loading, listPackages, fetchPackages } = useSession();
  const [selectedSportId, setSelectedSportId] = useState(null);
  const [selectedSaleId, setSelectedSaleId] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState({
    packageId: null,
    sportId: null,
  });
  const [isOneOnOneClicked, setIsOneOnOneClicked] = useState(
    typeFromQuery === "1-1",
  );
  const [isGroupClicked, setIsGroupClicked] = useState(
    typeFromQuery === "Group",
  );
  const [type, setType] = useState(typeFromQuery || "1-1");
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (userDetails.is_self_pay === false) {
      navigate("/list-of-sports");
      return;
    } else {
      fetchPackages();
    }
  }, []);

  function handleOneOnOneClick() {
    setIsOneOnOneClicked(true);
    setIsGroupClicked(false);
    setType("1-1");
  }

  function handleGroupClick() {
    setIsOneOnOneClicked(false);
    setIsGroupClicked(true);
    setType("Group");
  }

  const handleProceed = () => {
    if (!selectedSportId || !selectedSaleId) {
      alert("Please select a sport and a sale first");
      return;
    }
    navigate(
      `/book-slots?sport_id=${selectedSportId}&sale_id=${selectedSaleId}`,
    );
  };

  if (loading) {
    return (
      <>
        <NavbarCustom />
        <Loader />
      </>
    );
  }

  return (
    <>
      <NavbarCustom />
      <div className="buy-packages-sports-container">
        <div className="buy-packages-header">
          <BackBtn />
          <div className="buy-packages-header-content">
            <h1 className="buy-packages-heading black-text-clip">
              Schedule Your Sessions
            </h1>
          </div>
        </div>

        <div className="filter-container" style={{ justifyContent: "center" }}>
          {/* <div className="space-adjuster"></div> */}
          <div className="buttons-container">
            <button
              className={`filter-button ${isOneOnOneClicked ? "clicked-btn" : ""}`}
              onClick={handleOneOnOneClick}
            >
              <span className="black-text-clip">1-1</span>
            </button>
            <button
              className={`filter-button ${isGroupClicked ? "clicked-btn" : ""}`}
              onClick={handleGroupClick}
            >
              <span className="black-text-clip">Group</span>
            </button>
          </div>
        </div>

        {listPackages && listPackages.length > 0 ? (
          listPackages.map((sportItem, sportIndex) => {
            const filteredPackages = sportItem.packages.filter((pkg) =>
              isOneOnOneClicked ? !pkg.is_group_session : pkg.is_group_session,
            );

            // 2. If there are no packages after filtering, do not render the sport title/container at all
            if (filteredPackages.length === 0) {
              return null;
            }

            return (
              <div className="buy-packages-preferred-sports" key={sportIndex}>
                <h2 className="black-text-clip">
                  {sportItem.sport.name} Packages
                </h2>

                <div className="buy-packages-preferred-sports-container">
                  {filteredPackages.map((pkg, pkgIndex) => (
                    <div
                      key={pkgIndex}
                      onClick={() => {
                        setSelectedSportId(sportItem?.sport.id);
                        setSelectedSaleId(pkg?.sale_id);
                      }}
                      className="package-card"
                      style={{ cursor: "pointer" }}
                    >
                      <ImageContainer
                        id={pkg?.sale_id}
                        name={
                          pkg.is_unlimited
                            ? "Unlimited Sessions"
                            : `${pkg.remaining_sessions} Session Left`
                        }
                        image={
                          sportItem.sport.image
                            ? `${sportItem.sport.image}`
                            : "https://via.placeholder.com/150"
                        }
                        selectedSaleId={selectedSaleId}
                        selectedSportId={selectedSportId}
                        setSelectedSport={(id) => {
                          setSelectedSportId(sportItem?.sport?.id);
                          setSelectedSaleId(id);
                        }}
                        sportId={sportItem?.sport?.id}
                        isSelfPayMode={true}
                      />
                    </div>
                  ))}
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ textAlign: "center", padding: "20px", color: "#777" }}>
            No sessions found
          </div>
        )}

        <div className="p-submit-button-container">
          <button
            disabled={!selectedSaleId}
            type="button"
            className="p-submit-button"
            onClick={handleProceed}
          >
            Proceed
          </button>
        </div>
      </div>
    </>
  );
};
